import SeoPageLayout from "@/components/SeoPageLayout";

const KabaretNaKonferencje = () => (
  <SeoPageLayout title="Kabaret na konferencję - rozrywka na najwyższym poziomie">
    <p>
      Konferencje branżowe to wydarzenia, na których uczestnicy spędzają długie godziny słuchając prezentacji i wykładów. Kabaret na konferencję to sposób na odświeżenie programu, utrzymanie uwagi uczestników i stworzenie pozytywnych skojarzeń z Twoim wydarzeniem.
    </p>

    <h2 className="text-2xl font-bold text-foreground mt-10">Rola kabaretu na konferencji branżowej</h2>
    <p>
      Badania pokazują, że uwaga słuchaczy drastycznie spada po 45-60 minutach ciągłego słuchania. Przerwa na profesjonalny występ kabaretowy regeneruje uwagę, poprawia nastrój i zwiększa zaangażowanie uczestników w dalszą część programu. To inwestycja w jakość całego wydarzenia.
    </p>

    <h2 className="text-2xl font-bold text-foreground mt-10">Formaty kabaretowe na konferencje</h2>

    <h3 className="text-xl font-bold text-foreground mt-6">Keynote comedy</h3>
    <p>
      Humorystyczne wystąpienie otwierające lub zamykające konferencję. Łączy elementy motywacyjnego przemówienia z profesjonalnym humorem. Idealne na otwarcie, gdy chcemy od razu zbudować pozytywną energię.
    </p>

    <h3 className="text-xl font-bold text-foreground mt-6">Panel break entertainment</h3>
    <p>
      Krótki, 15-20 minutowy występ kabaretowy w przerwie między panelami dyskusyjnymi. Pomaga uczestnikom się zrelaksować i nabrać sił na dalszą część programu.
    </p>

    <h3 className="text-xl font-bold text-foreground mt-6">Gala dinner show</h3>
    <p>
      Pełnowymiarowy występ kabaretowy podczas kolacji galowej towarzyszącej konferencji. Trwa 45-60 minut i stanowi główną atrakcję wieczoru.
    </p>

    <h2 className="text-2xl font-bold text-foreground mt-10">Kabaret branżowy - humor dopasowany do tematyki</h2>
    <p>
      Nasi artyści potrafią przygotować materiał nawiązujący do tematyki konferencji i specyfiki branży. Żarty o codziennych wyzwaniach zawodowych, trendach branżowych czy znanych postaciach z sektora sprawiają, że humor trafia idealnie w gusta publiczności.
    </p>

    <h2 className="text-2xl font-bold text-foreground mt-10">Logistyka i wymagania techniczne</h2>
    <p>
      Na konferencji zazwyczaj dysponujemy sceną i profesjonalnym nagłośnieniem - wystarczy zarezerwować czas w programie. W razie potrzeby zapewniamy własne zaplecze techniczne. Dostosowujemy się do harmonogramu i wymogów organizatora.
    </p>
  </SeoPageLayout>
);

export default KabaretNaKonferencje;
